import { formatLocale } from 'app/utils/formatLocale';
import { SunburstPoint } from 'react-vis';

export function getTotal(node: SunburstPoint, format: boolean) {
  if (node.size) {
    if (format) {
      return formatLocale(node.size);
    }
    return node.size;
  }
  let total = 0;
  function traverse(cNode: SunburstPoint) {
    if (cNode.children) {
      cNode.children.forEach((child: SunburstPoint) => {
        if (child.size) {
          total += child.size;
        } else if (child.children) {
          traverse(child);
        }
      });
    }
  }
  traverse(node);
  if (format) {
    return formatLocale(total);
  }
  return total;
}
